let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8Z8LJ")).then(() => parcelRequire('15Yl4'));